import { Injectable } from '@angular/core';
import { FieldChanger, NodeNamer, TreeListService } from './tree-list.service';

export class PumpsetListNode {
  id: string;
  text: string;
  items: PumpsetListNode[];
}

@Injectable()
export class PumpsetListService {

  private pumpsetFamilies = [
    { family: "iH",   application: "Semicon",     label: "iH Pumps & Combinations",   division: "semicon" },
    // { family: "iGX",  application: "Semicon",     label: "iGX Pumps & Combinations",  division: "semicon" },
    { family: "iXH",  application: "Semicon",     label: "iXH Pumps & Combinations",  division: "semicon" },
    { family: "iXL",  application: "Semicon",     label: "iXL Pumps & Combinations",  division: "semicon" },
    // { family: "iXM",  application: "Semicon",     label: "iXM",  division: "semicon" },
    { family: "nXLi", application: "Scientific",  label: "nXLi", division: "scientific" },
    { family: "nXRi", application: "Scientific",  label: "nXRi", division: "scientific" },
    { family: "ESDP", application: "Scientific",  label: "Scroll Pumps", division: "scientific" },
    { family: "nXDS", application: "Scientific",  label: "Scroll Pumps nXDS", division: "scientific" },
    { family: "XDS",  application: "Scientific",  label: "Scroll Pumps",  division: "scientific" },
    { family: "ED660",  application: "Scientific",  label: "Small Rotary Pumps & Combinations",  division: "scientific" },
    { family: "E1M",  application: "Scientific",  label: "Small Rotary Pumps & Combinations",  division: "scientific" },
    { family: "E2M",  application: "Scientific",  label: "Small Rotary Pumps & Combinations",  division: "scientific" },
    { family: "RV",   application: "Scientific",  label: "Small Rotary Pumps & Combinations",  division: "scientific" },
    { family: "EDC",  application: "Industrial",  label: "EDC",  division: "industrial" },
    { family: "EDO",  application: "Industrial",  label: "EDO",  division: "industrial" },
    { family: "EDS",  application: "Industrial",  label: "EDS Pumps & Combinations",  division: "industrial" },
    { family: "EHR",  application: "Industrial",  label: "EHR",  division: "industrial" },
    { family: "ELRi", application: "Industrial",  label: "ELRi", division: "industrial" },
    // { family: "ES",   application: "Industrial",  label: "ES Pumps & Combinations",   division: "industrial" },
    { family: "EXS",   application: "Industrial",  label: "EXS",   division: "industrial" },
    { family: "GV",   application: "Industrial",  label: "GV Pumps & Combinations",   division: "industrial" },
    { family: "GXS",  application: "Industrial",  label: "GXS Pumps & Combinations",  division: "industrial" },
    { family: "IDX",  application: "Industrial",  label: "IDX Pumps & Combinations",  division: "industrial" },
    { family: "nES",  application: "Industrial",  label: "nES Pumps & Combinations",  division: "industrial" },
    { family: "E1M",  application: "Industrial",  label: "Large Rotary Pumps & Combinations",  division: "industrial" },
    { family: "E2M",  application: "Industrial",  label: "Large Rotary Pumps & Combinations",  division: "industrial" },
    { family: "SHR",  application: "Industrial",  label: "Liquid Ring Pumps",  division: "industrial" },
    { family: "CDX",  application: "Chemical",    label: "CDX Pumps & Combinations",  division: "industrial" },
    { family: "CXS",  application: "Chemical",    label: "CXS Pumps & Combinations",  division: "industrial" },
    { family: "EDP",  application: "Chemical",    label: "EDP Pumps & Combinations",  division: "industrial" }
  ];

  constructor(private treeListService:TreeListService) { }

  /**
   * Builds a pumpset tree list organised by offical->Application->family and "My Pumpsets" user defined pumpsets
   * @param pumpsetData
   */
  getPumpsetTreeList(pumpsetData): PumpsetListNode[] {
    let applications = {};
    applications["Chemical"] = {};
    applications["Industrial"] = {};
    applications["Scientific"] = {};
    applications["Semicon"] = {};
    for (let pumpsetFamily of this.pumpsetFamilies) {
        if(!applications[pumpsetFamily.application][pumpsetFamily.label]) {
            applications[pumpsetFamily.application][pumpsetFamily.label] = [];
        }
    }
    for (let pumpset of pumpsetData) {
        var blnFamilyFound = false;
        for (let pumpsetFamily of this.pumpsetFamilies) {
            if (pumpset.name.substring(0,3).match(new RegExp(pumpsetFamily.family.substring(0,3)))) {
                if (pumpset.division[0] == pumpsetFamily.division) {
                    blnFamilyFound = true;
                    applications[pumpsetFamily.application][pumpsetFamily.label].push({id:pumpset.id, name:pumpset.name, dataComment:pumpset.description, numberOfBoosterLayers:pumpset.numberOfBoosterLayers });
                    break;
                }
            }
        }
        if (blnFamilyFound == false) {
            if (!applications["Other pumpsets"]) {
                applications["Other pumpsets"] = {};
                applications["Other pumpsets"]["All"] = [];
            }
            applications["Other pumpsets"]["All"].push({id:pumpset.id, name:pumpset.name, dataComment:pumpset.description, numberOfBoosterLayers:pumpset.numberOfBoosterLayers });
        }
    }
    let applicationNodes = [];
    Object.keys(applications).forEach(function(key, index) {
            let applicationNode =  { isExpanded:false, id: key, text: key, items: []};
            Object.keys(applications[key]).forEach((function(key_, index_) {
              let familyNode = { id:key_, text: key_, items: []};
              for (let pumpset of applications[key][key_]) {
                let pumpsetNode = { id:pumpset.id, text: pumpset.name, name:pumpset.name, dataComment: pumpset.dataComment, numberOfBoosterLayers:pumpset.numberOfBoosterLayers, items: []};
                familyNode.items.push(pumpsetNode);
              }
              applicationNode.items.push(familyNode);
            }));
            applicationNodes.push(applicationNode);
     });
     let result = [];
     let officialNode = { isExpanded:true, id:"official", text: "Official", items: applicationNodes };
     result.push(officialNode);
     return result;
    }

    getCustomPumpsetItems(customPumpsetData){
      let customPumpsetfieldChanger:FieldChanger = {
        changeNames: (obj: any):any => {
          obj.text=obj.name;
          obj.isUser=true;
          return obj;
        }
      };
      let customPumpsetsNodeNamers:NodeNamer[] = [
        {getNodeName: (obj: any) => {
          return "My Pumpsets";
        }},
      ];
      return this.treeListService.getTree(customPumpsetData,customPumpsetfieldChanger,customPumpsetsNodeNamers);
    }

  }

